<template>
    <div>
        <br/>
        <vue-query-builder :rules="rules" :labels="labels" v-model="query" :max-depth="2"></vue-query-builder>

        <div class="form-group" style="margin-bottom: 1rem;">
            <v-btn color="primary" @click="search" :disabled="query == null">Search</v-btn>
            <v-btn @click="clear">Clear</v-btn>
            <v-btn @click="downloadCsv" style="float: right;" :loading="loadingCsv">Download CSV</v-btn>
        </div>

        <h2 class="mb-1">Columns</h2>
        <v-autocomplete :items="headers" :value="headersSelectedWithExtra" @input="addHeaders($event)"  return-object label="Select headers"
            multiple chips solo flat></v-autocomplete>

        <v-data-table
            :headers="headersWithAction"            
            :items="results"
            :loading="loading"
            :pagination.sync="options"
            :total-items="totalCount"
            :rows-per-page-items="[10, 20, 100, 500, 1000, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
            :disable-initial-sort="true"
        >
        <template v-slot:items="props">
            <template v-for="header in headersWithAction">
                <td :key="header.value" v-if="header.value === 'id'">
                    {{ props.item.Id }}
                </td>
                <td :key="header.value" v-if="header.value === 'title'">
                    {{ props.item.Title }}
                </td>
                <td :key="header.value" v-if="header.value === 'date'">
                    {{ props.item.Date | stringDateFormat }}
                </td>
                <td :key="header.value" v-if="header.value === 'chamber'">
                    {{ props.item.Chamber }}
                </td>            
                <td :key="header.value" v-if="header.value === 'outcome'">
                    {{ props.item.Outcome }}
                </td>                
                <td :key="header.value" v-if="header.value === 'ayes'">
                    {{ props.item.Ayes }}
                </td>                 
                <td :key="header.value" v-if="header.value === 'noes'">
                    {{ props.item.Noes }}
                </td>                               
                <td :key="header.value" v-if="header.value === 'ayesByParty'" style="vertical-align: top;">
                    <div v-for="group in groupVotes(props.item.Votes, 0)" :key="group.group">                        
                        <v-chip disabled small light>
                            <v-avatar :color="group.colour != null ? group.colour : '#919191'" >
                                <span style="color: #fff">{{ group.count }}</span>
                            </v-avatar>
                            {{ group.group }}
                        </v-chip>
                    </div>
                </td>
                <td :key="header.value" v-if="header.value === 'noesByParty'" style="vertical-align: top;">
                    <div v-for="group in groupVotes(props.item.Votes, 1)" :key="group.group">                        
                        <v-chip disabled small light>
                            <v-avatar :color="group.colour != null ? group.colour : '#919191'" >
                                <span style="color: #fff">{{ group.count }}</span>
                            </v-avatar>
                            {{ group.group }}
                        </v-chip>
                    </div>
                </td>
            </template>                              
            <td class="text-xs-left"><v-btn :to="'/StatisticalInformation/Divisions/Division/' + props.item.Id" small>View</v-btn></td>
        </template>
        </v-data-table>
        <br />
        <br />
    </div>
</template>
<script>
import axios from 'axios';
import rison from 'rison';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import VueQueryBuilder from 'vue-query-builder';
import moment from 'moment';
import Attendance from './Divisions/Attendance';
import VotedWithAgainst from './Divisions/VotedWithAgainst.vue';
import VotedIndividualWithAgainst from './Divisions/VotedIndividualWithAgainst.vue';
import VotedIndividualWithAgainstIndividual from './Divisions/VotedIndividualWithAgainstIndividual.vue';
import WonLostBy from './Divisions/WonLostBy.vue';
import ParliamentLookup from './Divisions/ParliamentLookup.vue';
import SplitVote from './Divisions/SplitVote.vue';

const defaultColumns = [ 'id', 'title', 'date', 'chamber', 'outcome' ];

export default {
    components: {
        VueQueryBuilder
    },
    created() {
        this.populateHeaders();
        this.populateQuery();
        this.$watch('headersWithAction', function(newVal, oldVal) {                
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {                    
                this.search();
            }                    
        });        
    },
    data() {
        return {
            results: [],
            totalCount: 0,
            options: { rowsPerPage: 20 },
            headersSelected: [],
            headersExtra: [],
            labels: {
                matchTypes: [
                    { id: 'all', label: 'Match all of the below criteria groups'},
                    { id: 'any', label: 'Match any of the below criteria groups'}
                ],
                addRule: 'Add Criteria'
            },        
            error: false,    
            headers: [
                {
                    text: 'Id',
                    value: 'id'
                },
                {
                    text: 'Title',
                    value: 'title'
                },
                {
                    text: 'Date',
                    value: 'date'
                },
                {
                    text: 'Chamber',
                    value: 'chamber'
                },
                {
                    text: 'Outcome',
                    value: 'outcome'
                },
                {
                    text: 'Ayes',
                    value: 'ayes'
                },
                {
                    text: 'Noes',
                    value: 'noes'
                },
                {
                    text: 'Ayes by party',
                    value: 'ayesByParty'
                },
                {
                    text: 'Noes by party',
                    value: 'noesByParty'
                }
            ],
            loading: false,
            loadingCsv: false,
            rules: [
            {
                type: "custom-component",
                id: "attendance",
                label: "(Individual) attendance",
                operators: ["of"],    
                default: JSON.stringify({ attendance: null, individual: null }),            
                component: Attendance
            },                 
            {
                type: "select",
                id: "chamber",
                label: "Chamber",
                choices: [
                    { label: "House of Representatives", value: "0" },
                    { label: "Senate", value: "1" }
                ]
            },                
            {
                type: "text",
                id: "divisionTitle",
                label: "Division title",
                operators: ["Contains"]
            },
            {
                type: "custom-component",
                id: "parliament",
                label: "Parliament",
                operators: ["of"],
                component: ParliamentLookup
            }, 
            {
                type: "custom-component",
                id: "splitVote",
                label: "Split vote",
                operators: ["of"],                
                component: SplitVote
            },            
            {
                type: "custom-component",
                id: "votedIndividualWithAgainstIndividual",
                label: "(Individual) voted with / against (Individual)",
                operators: ["of"],
                default: JSON.stringify({ direction: null, partyA: null, partyB: null }),
                component: VotedIndividualWithAgainstIndividual
            },
            {
                type: "custom-component",
                id: "votedIndividualWithAgainst",
                label: "(Individual) voted with / against (Party)",
                operators: ["of"],
                default: JSON.stringify({ direction: null, partyA: null, partyB: null }),
                component: VotedIndividualWithAgainst
            },                                                                            
            {
                type: "custom-component",
                id: "votedWithAgainst",
                label: "(Party) voted with / against (Party)",
                operators: ["of"],
                default: JSON.stringify({ direction: null, partyA: null, partyB: null }),
                component: VotedWithAgainst
            },            
            {
                type: "custom-component",
                id: "wonLostBy",
                label: "Won / Lost by",
                operators: ["by"],
                default: JSON.stringify({ outcome: null, party: null }),
                component: WonLostBy
            },
            ],
            query: {"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"parliament","selectedOperator":"of","selectedOperand":"Parliament","value":47}},{"type":"query-builder-rule","query":{"rule":"chamber","selectedOperand":"Chamber","value":"0"}}]}
        }
    },
    computed: {
        headersWithAction: function () {
            return [...this.headersSelected, ...this.headersExtra.filter(he => this.headersSelected.findIndex(h => h.value === he.value) === -1), {
                text: 'Actions',
                value: 'actions',
                sortable: false
            }]
        },
        headersSelectedWithExtra: function () {
            return [...this.headersSelected, ...this.headersExtra.filter(he => this.headersSelected.findIndex(h => h.value === he.value) === -1)];
        },
    },
    watch: {
        options: {
            handler (newVal, oldVal) {                                                                         
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal) && oldVal.totalItems != null) {                                                
                    this.search();
                }                    
            },
            deep: true
        }
    },
    methods: {
        populateHeaders() {
            this.headersSelected = this.headers.filter(h => defaultColumns.includes(h.value));
        },        
        populateQuery() {
            let search = false;

            const params = new URLSearchParams(window.location.search);
            if (params.has('dq')) {
                const value = params.get('dq');
                this.query = rison.decode(value);
                search = true;
            }
            if (params.has('dh')) {
                const value = params.get('dh');
                this.headersSelected = rison.decode(value);
                search = true;
            }

            if (search) {
                this.search();
            }
        },
        groupVotes(data, voteType) {
            if (data == null) { return []; }
            const groupedData = data
                .filter(v => v.VoteTypeId === voteType)
                .reduce((acc, item) => {
            const groupKey = item.Party === "IND" ? item.PersonFamilyName : item.Party;

            if (!acc[groupKey]) {
                acc[groupKey] = { count: 0, colour: item.PartyColour };
            }

            acc[groupKey].count++;

            return acc;
            }, {});

            const result = Object.keys(groupedData).map(key => ({
            group: key,
            count: groupedData[key].count,
            colour: groupedData[key].colour
            }));

            result.sort((a, b) => {
            if (b.count === a.count) {
                return a.group.localeCompare(b.group);
            }
            return b.count - a.count;
            });            

            return result;
        },
        search: function () {
            this.loading = true;

            const divisionQueryEncoded = rison.encode(this.query);
            const headersEncoded = rison.encode(this.headersSelected);
            
            let url = new URL(window.location.href);
            url.searchParams.set('dq', divisionQueryEncoded);
            url.searchParams.set('dh', headersEncoded);
            window.history.replaceState({}, '', url);

            const adjustedOptions = {
                ...this.options , 
                sortBy: [ this.options.sortBy ],
                sortDesc: [ this.options.descending ],
                itemsPerPage: this.options.rowsPerPage
            };                  
            axios.post('/api/divisionsSearch/Search', { query: this.query, headers: this.headersWithAction, ...adjustedOptions })           
                .then(response => { 
                    this.results = response.data.Results;
                    this.totalCount = response.data.TotalCount;
                    this.loading = false;


                })
                .catch(error => {
                    this.showError();
                    this.loading = false;
                });        
        },
        clear: function() {
            this.query = {
                logicalOperator: "all",
                children: []
            };
            this.headersSelected = this.headers.filter(h => defaultColumns.includes(h.value));
            let url = new URL(window.location.href);            
            url.searchParams.delete('dq');
            url.searchParams.delete('dh');            
        }, 
        addHeaders: function(headers) {
            // add to headers selected, except for those in extra.
            this.headersSelected = headers.filter(e => !this.headersExtra.map(h => h.value).includes(e.value));
        },
        downloadCsv: function () {
            this.loadingCsv = true;            
            const url = `${apiUri}/api/divisionsSearch/Csv`;

            // options adjusted for this vuetify version
            const adjustedOptions = {...this.options , sortBy: [ this.options.sortBy ], sortDesc: [ this.options.descending ] };                    
            const data = { query: this.query, headers: this.headersWithAction.filter(h => h.value != 'photo'), ...adjustedOptions, itemsPerPage: -1 };
            // Use XMLHttpRequest instead of Jquery $ajax
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = () => {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    // Give filename you wish to download
                    a.download = "HandbookDivisionsAdvancedSearch_" + moment(new Date()).format("YYYYMMDD") + ".csv";
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    this.loadingCsv = false;
                }
            };
            // Post data to URL which handles post request
            xhttp.open("POST", url);
            xhttp.setRequestHeader("Content-Type", "application/json");
            // You should set responseType as blob for binary responses
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(data));
        },
    }    
}
</script>
<style>
    @import
    'https://unpkg.com/vue-query-builder@0.7.1/dist/VueQueryBuilder.css';
</style>
<style scoped>
    .theme--light.v-chip {
        background: #dddddd;
        color: #000;
    }
    .theme--light.v-chip .v-avatar{
        color: #fff;
    }
</style>